import { useState } from 'react';

export const Logo = ({ className = 'h-10 w-auto', testId = 'logo' }) => {
  const [failed, setFailed] = useState(false);

  if (!failed) {
    return (
      <img
        src="/logo.png"
        alt="JN Automações"
        data-testid={testId}
        className={className}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <svg
      viewBox="0 0 210 48"
      className={className}
      fill="none"
      role="img"
      aria-label="JN Automações"
      data-testid={testId}
    >
      <rect x="1" y="1" width="46" height="46" stroke="#4a4d52" strokeWidth="1" />
      <text
        x="24"
        y="31"
        textAnchor="middle"
        fontFamily="'JetBrains Mono', monospace"
        fontSize="19"
        fontWeight="700"
        fill="#d4d8dc"
      >
        JN
      </text>
      <text
        x="60"
        y="30"
        fontFamily="'JetBrains Mono', monospace"
        fontSize="12"
        letterSpacing="5"
        fill="#8b8f96"
      >
        AUTOMAÇÕES
      </text>
    </svg>
  );
};
